const setBasicInfoTab = (basicInfoData,requestJSON,Moment) => {
    if (basicInfoData !== undefined && basicInfoData !== {}) {
        // if (basicInfoData.prefix !== undefined && basicInfoData.prefix !== null && basicInfoData.prefix.value !== "") { requestJSON = { ...requestJSON, "prefix": basicInfoData.prefix.value } }
        if (basicInfoData.firstName !== undefined && basicInfoData.firstName !== "") { requestJSON = { ...requestJSON, "firstName": basicInfoData.firstName } }
        if (basicInfoData.middleName !== undefined && basicInfoData.middleName !== "") { requestJSON = { ...requestJSON, "middleName": basicInfoData.middleName } }
        if (basicInfoData.lastName !== undefined && basicInfoData.lastName !== "") { requestJSON = { ...requestJSON, "lastName": basicInfoData.lastName } }
        if (basicInfoData.suffix !== undefined && basicInfoData.suffix !== null && basicInfoData.suffix.value !== "") { requestJSON = { ...requestJSON, "suffix": basicInfoData.suffix.value } }
        if (basicInfoData.dob !== undefined && basicInfoData.dob !== "") { requestJSON = { ...requestJSON, "dateOfBirth": Moment(basicInfoData.dob).format('YYYY-MM-DD') } }
        if (basicInfoData.ssn !== undefined && basicInfoData.ssn !== "") { requestJSON = { ...requestJSON, "ssn": basicInfoData.ssn.replace(/-|\s/g, "") } }
        if (basicInfoData.gender !== undefined && basicInfoData.gender !== null && basicInfoData.gender.value !== "") { requestJSON = { ...requestJSON, "gender": basicInfoData.gender.value } }
        
        if (basicInfoData.race !== undefined && basicInfoData.race !== null && basicInfoData.race !== [] && basicInfoData.race.length !== 0) {            
            let raceData = [] ;
            raceData.push({ "code": basicInfoData.race.value, "value": basicInfoData.race.label });
            requestJSON = { ...requestJSON, "races": raceData }
        }

        if (basicInfoData.ethnicity !== undefined && basicInfoData.ethnicity !== null && basicInfoData.ethnicity !== [] && basicInfoData.ethnicity.length !== 0) {
            let ethnicitiesData = [] ;
            ethnicitiesData.push({ "code": basicInfoData.ethnicity.value, "value": basicInfoData.ethnicity.label });
            requestJSON = { ...requestJSON, "ethnicities": ethnicitiesData }
        }

        if (basicInfoData.species !== undefined && basicInfoData.species !== null && basicInfoData.species.value !== "") { requestJSON = { ...requestJSON, "species": basicInfoData.species.value } }
        
        if (basicInfoData.childProofCaps !== undefined && basicInfoData.childProofCaps !== null && basicInfoData.childProofCaps.value !=="")
        {
            requestJSON = { ...requestJSON, "childProofCaps": basicInfoData.childProofCaps.value === 'Yes' ? true : false }
        }

        if (basicInfoData.knownAllergies !== undefined && basicInfoData.knownAllergies !== null && basicInfoData.knownAllergies.value !=="")
        {
            requestJSON = { ...requestJSON, "knownAllergies": basicInfoData.knownAllergies.value === 'Yes' ? true : false }
        }

        if (basicInfoData.medicareBeneficaryIdentifier !== undefined && basicInfoData.medicareBeneficaryIdentifier !== null && basicInfoData.medicareBeneficaryIdentifier !== "")
        {
            requestJSON = { ...requestJSON, "medicareBeneficiaryIdentifier": basicInfoData.medicareBeneficaryIdentifier.replace(/-|\s/g, "") }
        }

        if (basicInfoData.licenceValue !== undefined && basicInfoData.licenceValue !== null && basicInfoData.licenceValue !== "")
        {
            let mapIdentificationData=[];
            let identification={
                number:basicInfoData.licenceValue.replace(/-|\s/g, ""),
                type:"Driver's License",
                typeCode:"06"
            };
            mapIdentificationData.push(identification);
            requestJSON = { ...requestJSON, "identifications": mapIdentificationData }
        }

        requestJSON = { ...requestJSON, "pmsSource": "RX30" }
        let sourceTracking=[{
               "utmSource":localStorage.getItem("licence_number"),
               "utmMedium":"",
               "utmCampaign":"Patient Web Intake",
               "utmTerm": null, 
               "utmContent": null, 
               "createdDate":new Date()
            }]
        requestJSON = { ...requestJSON, "sourceTracking": sourceTracking }
        requestJSON = { ...requestJSON, "storeIdentifier": localStorage.getItem("licence_number") }

    }
    return requestJSON;
}

export default setBasicInfoTab